import { render } from "./StatisticsList.vue?vue&type=template&id=8c61d6f6&scoped=true"
import script from "./StatisticsList.vue?vue&type=script&lang=js"
export * from "./StatisticsList.vue?vue&type=script&lang=js"

import "./StatisticsList.vue?vue&type=style&index=0&id=8c61d6f6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c61d6f6"]])

export default __exports__